// extracted by mini-css-extract-plugin
module.exports = {"languages-popover-button":"w9g3w","languagesPopoverButton":"w9g3w"};